import Icon from '../components/Icon.vue'

Icon.register({
  'border-all': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32v-384c0-17.7 14.3-32 32-32h384zM384 96h-128v128h128v-128zM192 96h-128v128h128v-128zM64 416h128v-128h-128v128zM256 416h128v-128h-128v128z'
      }
    ]
  }
})
